import { render, staticRenderFns } from "./BookmarkComponent.vue?vue&type=template&id=432f1434&scoped=true"
import script from "./BookmarkComponent.vue?vue&type=script&lang=js"
export * from "./BookmarkComponent.vue?vue&type=script&lang=js"
import style0 from "./BookmarkComponent.vue?vue&type=style&index=0&id=432f1434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f1434",
  null
  
)

export default component.exports